const createEnvironmentFlags = (
  development = false,
  staging = false,
  production = false
) => ({ development, staging, production });

const flags = {
  modularizedRegistryTile: createEnvironmentFlags(true, true, true),
  cartViewedEvent: createEnvironmentFlags(true, true, true),
  fastFacets: createEnvironmentFlags(true, true, false),
  allowProductAddedEvent: createEnvironmentFlags(true, true, true),
  bugFixToGroupContrib: createEnvironmentFlags(true, true, false),
  webPreviewRefactor: createEnvironmentFlags(true, false, false),
  preauthNewCardTypes: createEnvironmentFlags(true, true, true),
  seatingChart: createEnvironmentFlags(true, true, false),
  seatingChartView2: createEnvironmentFlags(false, false, false),
  invitesModalRedirectTest: createEnvironmentFlags(false, false, false),
  refactorMobileRsvp: createEnvironmentFlags(true, true, false),
  dynamicThemeCount: createEnvironmentFlags(true, true, true),
  preauthChecklistCta: createEnvironmentFlags(true, true, true),
  weddingDashboardEditorialWithNoDek: createEnvironmentFlags(true, true, true),
  invitesPLPDraperJames: createEnvironmentFlags(false, false, false), // these need to be flipped at the same time
  invitesPLPLovelyBride: createEnvironmentFlags(false, false, true), // these need to be flipped at the same time
  invitesPLPHolidayCards: createEnvironmentFlags(true, true, false),
  invitesPDPCarousel: createEnvironmentFlags(true, true, true),
  websitesPDPCarousel: createEnvironmentFlags(true, true, true),
  invitesPDPCustomizeRedirect: createEnvironmentFlags(true, true, false),
  customizeUndoOnDelete: createEnvironmentFlags(true, true, true),
  customizeUndoOnAdd: createEnvironmentFlags(true, true, true),
  digitalStageTwo: createEnvironmentFlags(true, true, false),
  multiMediaDraftsOrders: createEnvironmentFlags(true, true, true),
  identifyGuestBeforeOnboarding: createEnvironmentFlags(true, true, true),
  onboardQuestionnaire: createEnvironmentFlags(true, true, true),
  websitePDPCarousel: createEnvironmentFlags(true, true, false),
  googleApiReduction: createEnvironmentFlags(true, true, true),
  showCollaboratorLink: createEnvironmentFlags(true, true, true),
  PLPImgBigger: createEnvironmentFlags(true, true, true),
  invitesPDPmagnifier: createEnvironmentFlags(true, true, true),
  cloneElementButton: createEnvironmentFlags(true, true, true),
  addressingListV2: createEnvironmentFlags(true, false, false),
  otherRegistriesTestEnabled: createEnvironmentFlags(true, true, false),
  publicWebsiteRsvpConfirmFlow: createEnvironmentFlags(true, true, false),
  persistentCart: createEnvironmentFlags(true, true, true),
  magnetInvites: createEnvironmentFlags(true, true, true),
  selectProductHeaderOptimizely: createEnvironmentFlags(true, true, true),
  invitesPlacementCards: createEnvironmentFlags(true, true, false), // INVITES-1172
  stdSizeSegments: createEnvironmentFlags(true, true, true), // INVITES-1228
  fontRenderFix: createEnvironmentFlags(true, true, false), // INVITES-1054
  digitalPreviewPage: createEnvironmentFlags(true, true, true), // INV-308
  invitesPLPEnableMotifs: createEnvironmentFlags(true, true, true), // INVITES-1109
  invitesPLPShowMatchingThemeCardsFirst: createEnvironmentFlags(true, true, true), // INV-398
  checklistV2: createEnvironmentFlags(true, true, false),
  pdpModalModule: createEnvironmentFlags(true, true, false),
  specificCustomizationError: createEnvironmentFlags(true, true, true), // INV-68
  filteredPLPUrls: createEnvironmentFlags(true, true, true), // INV-497
};

const getEnvironment = () => {
  const zolaEnv = window.zola && window.zola.env;
  switch (zolaEnv) {
    case 'development':
    case 'dev':
      return 'development';
    case 'staging':
    case 'stage':
      return 'staging';
    case 'production':
    case 'prod':
      return 'production';
    default:
      return 'production';
  }
};

const get = (flag) => {
  if (flags[flag]) {
    return Boolean(flags[flag][getEnvironment()]);
  }
  return false;
};

export default {
  get
};



// WEBPACK FOOTER //
// ./src/util/featureFlags.js